import React from "react";

import LongVersion from "./PrintPostEditorInstagramLong.jsx";
import NormalVersion from "./PrintPostEditorInstagramNormal.jsx";

function PostEditor({ shouldUseLongImage, ...rest }) {
  if (shouldUseLongImage) {
    return <LongVersion {...rest} />;
  }

  return <NormalVersion {...rest} />;
}
export default PostEditor;
